export type { FC } from "react";

export enum ETabs {
  PLANS,
  PACKAGES,
  SETTLEMENTS,
  INVOICES,
  PAYMENTS,
}

export interface Props {}
